 jQuery(function($){  
//$(".p_sleep-support-hydration-gut-balance").html($(".p_sleep-support-hydration-gut-balance").html().replace(/SLEEP SUPPORT/g,'<i>SLEEP SUPPORT</i>'));
 //  $(".p_relaxation-hydration-gut-balance").html($(".p_relaxation-hydration-gut-balance").html().replace(/RELAXATION/g,'<i>RELAXATION</i>'));
 //  $(".p_energy-hydration-gut-balance").html($(".p_energy-hydration-gut-balance").html().replace(/ENERGY/g,'<i>ENERGY</i>'));
  });